module.exports = __webpack_public_path__ + "static/photo-3-f222a18db6f1721ac75a68dd4468897c.jpg";